export default defineNuxtRouteMiddleware(async () => {
  const { detectAndSetCountry } = useCountryDetection();
  await detectAndSetCountry();
});
